// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4af3686b","239":"b7875d21","488":"e27bd86d","732":"ac4fdb0b"}[chunkId] + ".chunk.js";
};